export default __webpack_public_path__ + "static/media/pantry1-afterD-1920w.f1a24204.webp";